import $ from "jquery"; /*引入jquery*/
import getCookie from "../common/getCookie";
import getURLParameter from "../common/getURLParameter";
import { report } from '../common/luna_track/clickReport.js'

const { firstJump = "" } = getURLParameter();

function drawHtml(flag) {
    setTimeout(() => {
        report({
            action: 1001,
            element_id: 99,
            element_param: { name: 'tanchuang' }
        })
    }, 1000);
    return `
        <section class="tt_container">
            <div class="tt_mask" style="display: ${flag ? "none" : "block"}">
                <div class="tt_dialog">
                    <p>
                        ${getCookie('jumpAppletUrlType') === '1' ? '打开58同城小程序' : '打开58招聘抖音小程序'}
                    </p>
                    <ul>
                        <li class="confirm">现在打开</li>
                        <li class="cancel">以后再说</li>
                    </ul>
                </div>
            </div>
        </section>
    `;
}

export function drawTtDialog() {
    if (firstJump === '1' && decodeURIComponent(getCookie('jumpAppletUrlBase')) !== 'null') {
        return drawHtml();
    }

    return "";
}

export function eventBindTtDialog() {
    function cancel() {
        $(".tt_mask").css("display", "none");
    }

    $(".tt_dialog")
        .on("click", ".confirm", () => {
            report({
                action: 1003,
                element_id: 99,
                element_param: { name: 'click-xzdk' }
            })
            location.href = `${decodeURIComponent(getCookie('jumpAppletUrlBase'))}${getCookie('jumpAppletUrlQuery', false)}`
            
            cancel();
        })
        .on("click", ".cancel", () => {
            report({
                action: 1003,
                element_id: 99,
                element_param: { name: 'click-yhzs' }
            })
            cancel()
        });
}
